import { render } from "./Roomless.vue?vue&type=template&id=5fab6c04"
import script from "./Roomless.vue?vue&type=script&lang=js"
export * from "./Roomless.vue?vue&type=script&lang=js"
script.render = render

export default script